import {
  SEARCH,
  SELECT_TAB,
  CLEAR_FILTER,
  TRACK_AND_TRACE,
  UPDATE_SELECTED_CATEGORY_FILTERS,
} from './types/DashboardActionTypes';

export function trackAndTraceActionCreator(atatId) {
  return {
    type: TRACK_AND_TRACE,
    atatId,
  };
}

export function searchActionCreator(keyword) {
  return {
    type: SEARCH,
    keyword,
  };
}

export function selectTabActionCreator(activeTab) {
  return {
    type: SELECT_TAB,
    activeTab,
  };
}

export function clearFilterActionCreator() {
  return {
    type: CLEAR_FILTER,
    keyword: '',
    selectedCategoryFilters: [],
  };
}

export function updateSelectedCategoryFiltersActionCreator(selectedCategoryFilters) {
  return {
    type: UPDATE_SELECTED_CATEGORY_FILTERS,
    selectedCategoryFilters,
  };
}
